import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { UI } from "../data/ui";
import * as tablesEl from "../data/tables";
import * as tablesEn from "../data/tables.en";
import * as chAEl from "../data/chaptersA";
import * as chAEn from "../data/chaptersA.en";
import * as chBEl from "../data/chaptersB";
import * as chBEn from "../data/chaptersB.en";

const build = (t, a, b, lang) => ({ ...t, ...a, ...b, ui: UI[lang] });
const EL = build(tablesEl, chAEl, chBEl, 'el');
const EN = build(tablesEn, chAEn, chBEn, 'en');

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState('el');
  useEffect(() => {
    document.documentElement.lang = lang;
    document.title = lang === 'en'
      ? 'The Search for Homeric Ithaca'
      : 'Η αναζήτηση της Ομηρικής Ιθάκης';
  }, [lang]);
  const d = useMemo(() => (lang === 'en' ? EN : EL), [lang]);
  return (
    <LangContext.Provider value={{ lang, setLang, d, ui: d.ui }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
